import MAutomaticResponderSetting from './index.vue';

MAutomaticResponderSetting.install = app => {
  app.component(MAutomaticResponderSetting.name, MAutomaticResponderSetting);
};

export default MAutomaticResponderSetting;
